/**
 * Substitutes `{fieldName}` placeholders in a provider config field's
 * `defaultValueTemplate` with values from the current form config.
 *
 * Returns `null` when any referenced placeholder field is unset, empty
 * string, or empty array — caller should not apply a default in that case.
 */
export function resolveDefaultValueTemplate(
    template: string,
    config: Record<string, unknown>,
): string | null {
    let allFilled = true;
    const resolved = template.replace(/\{([a-zA-Z][a-zA-Z0-9_]*)\}/g, (_, name: string) => {
        const v = config[name];
        if (v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0)) {
            allFilled = false;
            return '';
        }
        return String(v);
    });
    return allFilled ? resolved : null;
}
